import React from 'react';
import useIsMobile from '../../shared/hooks/useIsMobile';
import ContactMobile from './Contact.mobile';
import ContactDesktop from './Contact.desktop';

const ContactFeature = () => {
  const isMobile = useIsMobile();
  const View = isMobile ? ContactMobile : ContactDesktop;
  return <View />;
};

export default ContactFeature;
